export const blockIconsCommunicationMarkEmailReadNew = (
	<span className='material-symbols-outlined'>mark_email_read</span>
);
